import styled from '../../config/theme'

const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.mediaQueries.layout};
  margin: 0 auto;
  flex: 1;

  padding: 50px 0; 
  // margin-top: 70px;

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    max-width: ${props => props.theme.mediaQueries.layoutMobile};
    margin: 0 auto;
    // padding: 90px 0; 
  }

  @media screen and (max-width: 812px) {
    h1 {
      justify-content: center;
    }
  }
`

export { Container }
